var $3ad4dfd69f313220$exports = {};
$3ad4dfd69f313220$exports = {
  "backButton": args => `Voltar ao ${args.prevMenuButton}`,
  "moreActions": `Mais a\xe7\xf5es`,
  "unavailable": `Indispon\xedvel, expandir para mais detalhes`
};
export { $3ad4dfd69f313220$exports as default };